import { sendAnalyticsToGA } from "./commanFunctions";

const platform = /android/i.test(navigator.userAgent)
  ? "android"
  : /iPhone|iPad|iOS/i.test(navigator.userAgent)
  ? "ios"
  : "web";

export const extractPath = (hash = "") => {
  // Remove the leading "#?" or "#/" or "#" if present
  const cleanedHash = hash.replace(/^#\/?/, ""); // e.g. "?path=trip" or "path=trip"

  const searchParams = new URLSearchParams(cleanedHash);
  const pathParam = searchParams.get("path");

  if (!pathParam || pathParam === "/") {
    return "explore";
  }

  return pathParam;
};

export const trackFavorited = ({
  action,
  path = window.location.hash,
  store_id,
  name,
}) => {
  console.log(path);
  if (process.env.REACT_APP_GA_ENABLED !== "true") return;

  const previousPath = sessionStorage.getItem("previousPath") || "";
  const isOnDescriptionPage = path.includes("description");

  // Apply logic
  const isPersonalized =
    path.includes("personalizedStay") ||
    (isOnDescriptionPage && previousPath.includes("personalizedStay"));

  sendAnalyticsToGA({
    event: "FAVORITED",
    action: action,
    isPersonalized: isPersonalized,
    path: extractPath(path),
    platform: platform,
    name: name,
    store_id: store_id,
  });
};
export const trackCTA = ({
  action,
  isFavorite = false,
  storeName = "details page",
}) => {
  if (process.env.REACT_APP_GA_ENABLED !== "true") return;

  const previousPath = sessionStorage.getItem("previousPath") || "";
  const isPersonalized = previousPath.includes("personalizedStay");

  sendAnalyticsToGA({
    event: "CALL_TO_ACTION",
    action: action,
    isFavorite: isFavorite,
    isPersonalized: isPersonalized,
    platform: platform,
    name: storeName,
  });
};

export const trackWidgetClick = ({
  action = "not_explore",
  type = "",
  isFavorite = false,
  path = window.location.hash,
  widget_name
}) => {
  if (process.env.REACT_APP_GA_ENABLED !== "true") return;

  const previousPath = sessionStorage.getItem("previousPath") || "";
  const isOnDescriptionPage = path.includes("description");

  const isPersonalized =
    path.includes("personalizedStay") ||
    (isOnDescriptionPage && previousPath.includes("personalizedStay"));

  sendAnalyticsToGA({
    event: "WIDGET_CLICK",
    action, // All / Events / Dining / etc
    isFavorite,
    isPersonalized,
    path: extractPath(path),
    platform,
    type,
    widget_name,
  });
};


export const trackSearch = ({
  query = "",
  path = window.location.hash,
}) => {
  if (process.env.REACT_APP_GA_ENABLED !== "true") return;

  sendAnalyticsToGA({
    event: "SEARCH",
    action: extractPath(path),
    query,
    path: extractPath(path),
    platform,
  });
};


export const trackExit = ({
  action = window.location.hash,
  tab = "",
}) => {
  if (process.env.REACT_APP_GA_ENABLED !== "true") return;

  sendAnalyticsToGA({
    event: "EXIT",
    action: extractPath(action),          // e.g., "Details Screen/Map"
    tab,             // e.g., "explore" or "map"
    platform,
  });
};


export const trackSupport = ({
  path = window.location.hash,
} = {}) => {
  if (process.env.REACT_APP_GA_ENABLED !== "true") return;

  sendAnalyticsToGA({
    action:"SUPPORT",
    event: "SUPPORT_CLICKED",
    path: extractPath(path),
    platform,
  });
};


export const trackExploreMore = ({
  groupName = "",
  path = window.location.hash,
}) => {
  if (process.env.REACT_APP_GA_ENABLED !== "true") return;

  sendAnalyticsToGA({
    event: "EXPLORE_MORE",     // category/eventName
    action: groupName,         // action: group_name
    path: extractPath(path),   // extract meaningful path from hash
    platform: platform,
  });
};

export const trackPersonalizedFlow = ({
  action = "",
  question = "",
  choices = "",
  selection_name = "",
  step = 0
}) => {
  if (process.env.REACT_APP_GA_ENABLED !== "true") return;

  sendAnalyticsToGA({
    event: "PERSONALIZED_FLOW",
    action: action,                 // e.g., "start", "step_1", "submit"
    question: question,             // e.g., "What are you interested in?"
    choices: choices,               // e.g., "Dining,Events,Nature"
    selection_name: selection_name, // e.g., "Dining,Nature"
    step: step,
    platform: platform,
  });
};
